import logoHeader from './lplogo_header.png';
import image404 from './image_404.png';
import React, { Component } from 'react';
import './Page404.css'

class Page404 extends Component {

    render() {
        return (
            <div className="error-page">
                <div className="logo-header">
                    <img alt="Bulk Manager" src={logoHeader} height="32" />
                    <h2>BULK MANAGER</h2>
                </div>
                <div className="not-found">
                    <img alt="Erro 404" src={image404} />
                    <h1>Ooops!</h1>
                    <h2>Erro! A página que estava à procura não foi encontrada. Por favor, tente novamente mais tarde.</h2>
                    <div className="link-home">
                        <a href="/">Voltar para a página inicial</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default Page404;


// WEBPACK FOOTER //
// ./src/Page404.js